import { render, staticRenderFns } from "./CenterMenu.vue?vue&type=template&id=c0f72394&scoped=true"
import script from "./CenterMenu.vue?vue&type=script&lang=js"
export * from "./CenterMenu.vue?vue&type=script&lang=js"
import style0 from "./CenterMenu.vue?vue&type=style&index=0&id=c0f72394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f72394",
  null
  
)

export default component.exports